import { Box, Button, styled, Tab, Tabs, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const MainCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
}));

// export const TabHeader = styled(Tabs)(({ theme }) => ({
//   backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
//   minHeight: '70px',
//   '& .MuiTab-root': {
//     minWidth: 'unset',
//   },
//   '& .Mui-selected': {
//     borderBottom: '2px solid #3e8bff',
//   },
//   '& .PrivateTabIndicator-colorSecondary-2381': {
//     backgroundColor: 'none',
//   },
// }));

export const TabHeader = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  marginBottom: 10,
  // minHeight: '70px',
  '& .MuiTab-root': {
    minWidth: 'unset',
  },
  '& .MuiTabs-indicator': {
    backgroundColor: COLORS.PRIMARY,
  },
  '& .PrivateTabIndicator-colorSecondary-2381': {
    backgroundColor: 'none',
  },
}));

export const TabItem = styled(Tab)(({ theme }) => ({
  opacity: 1,
  '&.Mui-selected': {
    color: COLORS.PRIMARY,
  },
}));

export const ActiveTabContainer = styled(Box)(({ theme }) => ({
  flex: 1,
}));

export const TabContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
}));

export const HeaderCont = styled(Box)(({ theme }) => ({
  margin: '0 10px 10px 10px',
  padding: 10,
  // borderBottom: 'solid 1px #2D343E',
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const TitleCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 15,
}));

export const HeaderButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down(960)]: {
    width: 'unset',
    fontSize: 12,
    padding: '0px 12px',
  },
  width: 147,
  height: 36,
  border: 'solid 1px #3e8bff',
  borderRadius: 4,
  marginLeft: 'auto',
  backgroundColor: 'transparent',
}));

export const DeleteCont = styled(Box)(({ theme }) => ({
  margin: '0 10px 10px 10px',
  padding: '10px 10px 20px 10px ',
  // borderBottom: 'solid 1px #2D343E',
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  display: 'flex',
  alignItems: 'center',
  // [theme.breakpoints.down(960)]: {
  //   flexDirection: 'column',
  // },
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down(960)]: {
    fontSize: 10,
    padding: '0 10px',
  },
  height: 36,
  border: '1px solid #d22e2e',
  padding: '0 32px',
  fontSize: 13,
  backgroundColor: 'transparent',
}));

export const ModalCont = styled(Box)(({ theme }) => ({
  width: 500,
  height: 400,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 40,
  position: 'relative',
  [theme.breakpoints.down(960)]: {
    width: 'unset',
    height: 'unset',
    justifyContent: 'center',
    padding: '30px 20px',
    wordBreak: 'break-word',
  },
}));

export const ModalButton = styled(Button)(({ theme }) => ({
  width: 258,
  height: 44,
}));

export const ButtonCont = styled(Box)(({ theme }) => ({
  marginTop: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const TextGreyColor = styled(Typography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? '#98a1ac' : '#484c52',
}));
